import classes from './Card.module.scss'
import { Children } from 'react'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  id?: string
  hasShadow?: boolean
  isTransparentBackground?: boolean
  hasOverflowHidden?: boolean
  hasOpacity?: boolean
}

const Card = ({
  children,
  id,
  hasShadow = false,
  isTransparentBackground = false,
  hasOverflowHidden = false,
  hasOpacity = false
// eslint-disable-next-line complexity
}: Props) => {
  const shadowClass = hasShadow
    ? classes.shadow
    : ''

  const backgroundClass = isTransparentBackground
    ? classes.TransparentBackground
    : ''

  const overflowClass = hasOverflowHidden
    ? classes.OverflowHidden
    : ''

  const disableClass = hasOpacity
    ? classes.Opacity
    : ''

  const cardClass = [
    classes.Card,
    shadowClass,
    backgroundClass,
    overflowClass,
    disableClass
  ].filter(styleClass => styleClass).join(' ')

  return (
    <div
      className={cardClass}
      data-testid={id}
    >
      {
        Children.count(children) > 1
          ? Children.map(children, (child, index) =>
            <div key={index}>
              {child}
            </div>
          )
          : children
      }
    </div>
  )
}

export default Card
